export default __webpack_public_path__ + "static/media/bathroom1-after-2048w.6b9d36fb.png";